import * as Yup from "yup";

export type TSmeUnmappedOfficeFieldValues = {
  officeIds: number[];
};

export const smeUnmappedOfficeValidationSchema = Yup.object().shape({
  officeIds: Yup.array().of(Yup.number()),
});
